import React from 'react';

import PageTitle from '../../../global/PageTitle/PageTitle'
import ListTable from '../../../global/ListTable/ListTable'
import './CompensationReview.css'

const columns = [
  { key: 'effectiveDate', label: 'Effective Date' },
  { key: 'process', label: 'Compensation Review Process' },
  { key: 'position', label: 'Position' },
  { key: 'statement', label: 'Compensation Review Statement PDF' }
]

const rows = []

const CompensationReview = () => {
  return (
    <div>
      <PageTitle title="My Compensation Review Statement History" />
      <div className="compensation-review-main">
        <ListTable columns={columns} rows={rows} />
      </div>
    </div>
  );
}

export default CompensationReview;
